import { useDispatch, useSelector } from "react-redux";
import BasicCardDocumentos from "../BasicCardDocumentos";
import InputForm from "../InputFormV2";
import { State } from "../../../../reducers";
import { useEffect, useState } from "react";

import InputChips from "../InputChips";
import DeleteIcon from '../../../../media/felsv/dark_recyclebin_icon.svg'
import EditIcon from '../../../../media/felsv/PenEdit.svg'
import SwitchTipoProductoDTE from "../BasicSwitchTipoProducto";
import useCreditoFiscal from "../../../../actions/credito-fiscal.actions";
import { Pagination } from "../../../../components/Pagination";

import HelpIcon from '../../../../media/felsv/help-circle-svgrepo-com.svg';
import PorcentageIcon from '../../../../media/felsv/Porcentaje.svg'
import DolarIcon from '../../../../media/felsv/Dollar.svg'
import { actionGeneral, actionsLogin } from "../../../../actions/action-creators";
import { bindActionCreators } from "redux";
import OtrosDocAsociados from "../../../EmitirFactura/Components/GeneracionFactura/OtrosDocAsociados";
import { BannerElegirSucursal } from "../../../../components/Banner/BannerElegirSucursal";
import DocumentosReceptor from "../../../../components/DocumentoReceptor/DocumentosReceptor";
import ObservacionesDocumentoBase from "../../../../components/ObservacionesDocumento/ObservacionesDocumento";
import { CREDITO_FISCAL_TYPES } from "../../../../constants/credito-fiscal.types";
import FormaPago from "../FormaPago";
import { esCatalogoProductoByTipo, formatearNum, processDetalleImpuestosHTML, getDigitosCalculables } from "../../../../actions/utils-documentos.actions";
import { Tooltip } from "../../../../components/Tooltip/Tooltip";
import InputSwitchDescripcion, { CheckBoxFlag } from "../InputSwitchDescripcion";

export default function FormulariosCCF (){
    const {fecha_actual} = useSelector((state: State) => state.general)
    const {datos: datosUsuario} = useSelector((state: State) => state.userLogin)
    const {formCliente, errorsCliente, formProducto, errorsProducto, calculosProducto, productos, tableProductos, retencionRenta, formObservaciones} = useSelector((state: State) => state.creditoFiscal)
    const {departamentos, municipios, actividadesEconomicas, unidadesMedida, productos: productosCatalogo} = useSelector((state: State) => state.catalogos)
    const {datos} = useSelector((state: State) => state.userLogin)
    
    const [customDescripcion, setCustomDescripcion] = useState(false);
    const [checkTextoEnrequecido, setCheckTextoEnrequecido] = useState(false);

    const propinaConfig = useSelector((state: State) => state.userLogin.propina);
    const { propina_activa, cantidad_propina } = propinaConfig;

    const {
        onChangeFormCliente,
        onChangeFormProducto,
        onChangeSelectCatalogoProducto,
        cargarDatosIniciales,
        buscarCliente,

        button_onClickAgregarProducto,
        button_onClickLimpiarFormProducto,

        validateFormCliente,
        validateFormProducto,

        actionButton_editar,
        actionButton_eliminarProducto,
        setTableProductos,
        calculosProductos,

        cargarSucursales,
        handleChangeRetencionRenta,
        button_onClickAsociarNotaRemision,
        button_onClickAsociarClienteFeles,
    } = useCreditoFiscal()

    const dispatch = useDispatch()
    const {suscripcionGetFacturasDisponibles} = bindActionCreators(actionsLogin, dispatch)
    const {getFechaHora, validateHorarioSucursal, validateUsoModulo} = bindActionCreators(actionGeneral, dispatch)
    
    const handleChangeFormCliente = (e: any) => {
        onChangeFormCliente(e.target.name, e.target.value)
    }

    const handleChangeFormProducto = (e: any) => {
        onChangeFormProducto(e.target.name, e.target.value)
        if (e.target.name === "descripcion" && e.target.value === "") {setCustomDescripcion(false)}
    }

    const handleBlurFormCliente = async(e: any) => {
        validateFormCliente(e.target.name, e.target.value)
        if(e.target.name === 'noDocumento') await buscarCliente()
    }

    const handleBlurFormProducto = (e: any) => {
        validateFormProducto(e.target.name, e.target.value)
    }

    const handleSelectCatalogoProducto = (e: any) => {
        if (e.label != -1) onChangeSelectCatalogoProducto(e.value);
        else {
            setCustomDescripcion(true);
            setCheckTextoEnrequecido(false);
            onChangeFormProducto('descripcion', e.value, {clave: '', tributos: []});
        }
    }

    useEffect(() => {
        window.scroll(0,0)
        validateUsoModulo()
        validateHorarioSucursal()
        suscripcionGetFacturasDisponibles()
        cargarSucursales()
        cargarDatosIniciales()
        getFechaHora()
    }, [])
    
    useEffect(() => {
        setTableProductos(productos)
    }, [productos])

    return(
        <>
            <BannerElegirSucursal />
            <div className="otros-documentos-container">                   
                <div className='dos-columnas-resp'>
                    <div className='form-content'>
                        <BasicCardDocumentos title="Datos del cliente">
                            <div style={{ display: 'flex', gap: '16px' }}>
                                <InputForm required name = 'granContribuyente' label = 'Gran contribuyente' type = 'checkbox' value = {formCliente.granContribuyente} onChange = {(e: any) => onChangeFormCliente('granContribuyente', !formCliente.granContribuyente)}/>
                                {
                                    datosUsuario?.socio &&
                                        <div style={{display: 'flex', justifyContent: 'center'}}>
                                            <button onClick={button_onClickAsociarClienteFeles} style={{display: 'flex', width: 'auto', borderRadius: '100px'}} className="button m">Asociar cliente FELES</button>
                                        </div>
                                } 
                            </div>   
                            <div style={{ display: 'flex', gap: '16px' }}>
                                {
                                    propinaConfig?.propina_activa  &&
                                    <InputForm required name = 'Propina' label = 'Propina' type = 'checkbox' value = {formCliente.propina} onChange = {(e: any) => onChangeFormCliente('propina', !formCliente.propina)}/>
                                }
                            </div>                   
                            <div className='w-layout-hflex h-inputs'>
                                <InputForm name = 'fecha' placeholder = 'Fecha de emisión' label = 'Fecha' type = 'date' value = {fecha_actual?.FechaInput} error = {errorsCliente.fecha}/>
                                <InputForm onBlur = {handleBlurFormCliente} required name = 'noDocumento' placeholder = 'NIT' label = 'NIT' type = 'text' value = {formCliente.noDocumento} error = {errorsCliente.noDocumento} onChange = {handleChangeFormCliente}/>
                            </div>
                            <div className='w-layout-hflex h-inputs'>
                                <InputForm maxLength = {250} onBlur = {handleBlurFormCliente} required name = 'nombre' placeholder = 'Nombre' label = 'Nombre' type = 'text' value = {formCliente.nombre} error = {errorsCliente.nombre} onChange = {handleChangeFormCliente}/>
                            </div>
                            <div className='w-layout-hflex h-inputs'>
                                <InputForm required options = {departamentos?.map((dep) => ({...dep, codigo_nombre: `${dep.codigo} - ${dep.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'departamento' placeholder = 'Departamento' label = 'Departamento' type = 'select' value = {formCliente.departamento} error = {errorsCliente.departamento} onChange = {(e: any) => onChangeFormCliente('departamento', e.value)}/>
                                <InputForm required options = {municipios?.map((mun) => ({...mun, codigo_nombre: `${mun?.codigo} - ${mun?.valor}`}))} keyNameText = 'codigo_nombre' keyNameValue = 'codigo' name = 'municipio' placeholder = 'Municipio' label = 'Municipio' type = 'select' value = {formCliente.municipio} error = {errorsCliente.municipio} onChange = {(e: any) => onChangeFormCliente('municipio', e.value)}/>
                            </div>
                            <div className='w-layout-hflex h-inputs'>
                                <InputForm maxLength = {200} onBlur = {handleBlurFormCliente} required name = 'direccion' placeholder = 'Dirección' label = 'Dirección' type = 'text' value = {formCliente.direccion} error = {errorsCliente.direccion} onChange = {handleChangeFormCliente}/>
                            </div>
                            <div className='w-layout-hflex h-inputs'>
                                <InputChips maxChips={5} chips={formCliente.chipsEmail} setChips={(chipsEmail: Array<string>) => onChangeFormCliente('chipsEmail', chipsEmail)} maxLength = {100} onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/>
                                {/* <InputForm maxLength = {50} onBlur = {handleBlurFormCliente} required name = 'email' placeholder = 'Correo electrónico' label = 'Correo electrónico' type = 'text' value = {formCliente.email} error = {errorsCliente.email} onChange = {handleChangeFormCliente}/> */}
                            </div>
                            <div className='w-layout-hflex h-inputs'>
                                <InputForm required options = {actividadesEconomicas.map((act) => ({...act, codigo_valor: `${act.codigo}-${act.valor}`}))} keyNameText = 'codigo_valor' keyNameValue = 'codigo' name = 'actividad' placeholder = 'Actividad económica' label = 'Actividad económica' type = 'select' value = {formCliente.actividad} error = {errorsCliente.actividad} onChange = {(e: any) => onChangeFormCliente('actividad', e.value)}/>
                                <InputForm onBlur = {handleBlurFormCliente} required name = 'telefono' placeholder = 'Teléfono celular' label = 'Teléfono celular' type = 'phone' value = {formCliente.telefono} error = {errorsCliente.telefono} onChange = {(phone: any) => onChangeFormCliente('telefono', phone)}/>
                            </div>
                            <div className='w-layout-hflex h-inputs'>
                                <div className='label-input'>
                                <InputForm maxLength = {14} onBlur = {handleBlurFormCliente} required name = 'nrc' placeholder = 'NRC' label = 'NRC' type = 'text' value = {formCliente.nrc} error = {errorsCliente.nrc} onChange = {handleChangeFormCliente}/>
                                </div><div className='label-input'></div>
                            </div>    
                            <hr className="separador"/>
                            <div style={{display: 'flex', justifyContent: 'center'}}>
                                <button onClick={button_onClickAsociarNotaRemision} style={{display: 'flex', width: '50%', borderRadius: '100px'}} className="button">Asociar notas de remisión</button>
                            </div>
                        </BasicCardDocumentos>
                    </div> 
                    <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ecd-0b1e6fa6' className='w-layout-cell'>
                        <BasicCardDocumentos title="Sucursal y serie">
                            <div className='w-layout-hflex h-inputs'>
                                <InputForm disabled={true} required options = {formCliente?.datosSucursal} keyNameText = 'nombre' keyNameValue = 'idsucursal' name = 'sucursal' placeholder = 'Sucursal' label = 'Sucursal' type = 'select' value = {formCliente.sucursal} error = {errorsCliente.sucursal} onChange = {(e: any) => onChangeFormCliente('sucursal', e.value)}/>
                                <InputForm disabled={!formCliente.loadedSucursal} required options = {formCliente?.datosSucursal?.find((suc: any) => suc?.idsucursal === formCliente?.sucursal)?.Documento?.map((doc: any) => ({...doc, serie_numero: `${doc.serie}-${doc.numeroactual}`}))} keyNameText = 'serie_numero' keyNameValue = 'idsucursaldocumento' name = 'serie' placeholder = 'Serie' label = 'Serie' type = 'select' value = {formCliente.serie} error = {errorsCliente.serie} onChange = {(e: any) => onChangeFormCliente('serie', e.value)}/>
                            </div>
                            <div>
                                <h3 className="card-title">Producto o Servicio</h3>
                            </div>
                            <hr className="separador"/>
                            <SwitchTipoProductoDTE producto = {!formProducto.servicio} setProducto = {() => onChangeFormProducto('servicio', false)} setServicio = {() => onChangeFormProducto('servicio', true)}/>
                            <div className="cf-row-inputs">
                            <InputForm required name = 'descripcion' label = 'Exento' type = 'checkbox' value = {formProducto.exento} onChange = {(e: any) => onChangeFormProducto('exento', !formProducto.exento)}/>
                            <InputForm required name = 'descripcion' label = 'Incluye IVA' type = 'checkbox' value = {formProducto.conIva} onChange = {(e: any) => onChangeFormProducto('conIva', !formProducto.conIva)}/>
                            <InputForm required name = 'descripcion' label = 'No sujeto' type = 'checkbox' value = {formProducto.noSujeto} onChange = {(e: any) => onChangeFormProducto('noSujeto', !formProducto.noSujeto)}/>
                            </div>
                            {!formProducto.exento && !formProducto.noSujeto &&
                                <p style={{color: '#019FC5'}}>Nota: Este {formProducto.servicio ? 'servicio' : 'producto'} lleva un 13% extra por concepto de IVA. ( {formProducto.servicio ? 'Servicio' : 'Producto'} gravado)</p>
                            }
                            {
                                (!customDescripcion && productosCatalogo.length > 0)
                                ?   
                                    <InputForm 
                                        enableCreate={true} required 
                                        label = 'Descripción' type = 'select' 
                                        options = {productosCatalogo.filter((prod) => esCatalogoProductoByTipo(formProducto.servicio, prod))} 
                                        keyNameText = 'descripcion' keyNameValue = 'clave' 
                                        onChange = {handleSelectCatalogoProducto} 
                                        value = {formProducto.clave} error = {errorsProducto.descripcion}
                                        componentSideLabel = {
                                            <CheckBoxFlag
                                              label="Activar texto con formato" 
                                              value={customDescripcion} 
                                              onChange={() => {
                                                setCustomDescripcion(true);
                                                setCheckTextoEnrequecido(true);
                                              }}
                                            />
                                        }
                                    />
                                : (
                                    <div className="w-layout-hflex h-inputs">
                                        <InputSwitchDescripcion defaultEnrequecido={checkTextoEnrequecido} className='m text-field w-input' maxLength = {1000} onBlur = {handleBlurFormProducto} required name = 'descripcion' placeholder = 'Descripción' label = 'Descripción' type = 'text' value = {formProducto.descripcion} error = {errorsProducto.descripcion} onChange = {handleChangeFormProducto}/>    
                                    </div>
                                )
                            }
                            <div style={{flexDirection: "row"}} >
                                <div className={`ef-form-producto-div4`}>
                                    <div className='label-input'>
                                        <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'cantidad' placeholder = '0' label = 'Cantidad' type = 'text' value = {formProducto.cantidad} error = {errorsProducto.cantidad} onChange = {handleChangeFormProducto}/>
                                    </div>
                                    <div className='label-input'>
                                    <InputForm type = 'select' options = {unidadesMedida} keyNameText = 'valor' keyNameValue = 'codigo' onChange = {(e: any) => onChangeFormProducto('unidadMedida', e.value)} label = 'Unidad de medida' value = {formProducto.unidadMedida}/>
                                    </div>
                                    <div className='label-input'>
                                        <InputForm maxLength = {15} onBlur = {handleBlurFormProducto} required name = 'precio' placeholder = '$0.00' label = 'Precio' type = 'text' value = {formProducto.precio} error = {errorsProducto.precio} onChange = {handleChangeFormProducto}/>
                                    </div>
                                    <div className='label-input'>
                                    <InputForm options = {[{nombre: 'Porcentaje'}, {nombre: 'Monto'}]} keyNameText = 'nombre' keyNameValue = 'nombre' name = 'tipoDescuento' placeholder = 'Tipo de descuento' label = 'Tipo de desc.' type = 'select' value = {formProducto.tipoDescuento} error = {null} onChange = {(e: any) => onChangeFormProducto('tipoDescuento', e.value)}/>
                                    </div>
                                    <div className='label-input'>
                                        <InputForm 
                                            maxLength = {formProducto.tipoDescuento === 'Porcentaje' ? 6 : 15}
                                            leftIcon = {formProducto.tipoDescuento === 'Porcentaje' ? PorcentageIcon : DolarIcon}
                                            type = 'text'
                                            value = {formProducto.descuento}
                                            name = 'descuento'
                                            onChange = {(e: any) => onChangeFormProducto(e.target.name, e.target.value)}
                                            placeholder = '0.00'
                                            label = 'Descuento'
                                            error = {errorsProducto.descuento}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="cf-calculos-producto">
                                <table>
                                    <tbody>
                                        <tr className="cf-subtotal">
                                            <td>Valor bruto</td>
                                            <td>{calculosProducto?.neto}</td>
                                        </tr>
                                        <tr className="cf-descuento">
                                            <td>Descuento</td>
                                            <td>{calculosProducto?.descuento}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Subtotal</td>
                                            <td>{calculosProducto?.subtotal}</td>
                                        </tr>
                                        <tr className="cf-subtotal">
                                            <td>Impuesto al Valor Agregado 13%
                                            </td>
                                            <td>{calculosProducto?.iva}</td>
                                        </tr>
                                        <tr className="cf-subtotal opacity-full-gray">
                                            <td>
                                                <Tooltip content='Cálculo de impuestos aplica en el resumen'>
                                                    <button className='table-action no-background'>
                                                        <img src={HelpIcon} className='help-icon-button' />
                                                    </button>
                                                </Tooltip>
                                                Otros impuestos
                                            </td>
                                            <td>{calculosProducto?.otrosImpuestos}</td>
                                        </tr>
                                        <tr className="cf-total">
                                            <td>Total</td>
                                            <td>{calculosProducto?.total}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div className="w-layout-hflex button-actions">
                                    <button className="button transparent" onClick={() => {button_onClickLimpiarFormProducto(); setCustomDescripcion(false)}}>Limpiar</button>
                                    <button className="button" onClick={() => {button_onClickAgregarProducto(); setCustomDescripcion(false)}}>Agregar</button>
                                </div>
                            </div>
                        </BasicCardDocumentos>
                    </div>
                </div>
                <div className="w-100">
                <div className="w-layout-layout bill-section wf-layout-layout">                    
                        <BasicCardDocumentos title="Detalle de productos o servicios" style={{maxWidth: '100%', boxShadow: "none"}}>
                            <div className="tab-plane">
                                <div className="table-facturacion-resp">
                                    <table className="table-main-responsive responsive-table-main td-left table-pointer">
                                        <thead>
                                            <tr>
                                                <td>Cantidad</td>
                                                <td>Tipo</td>
                                                <td>Descripción</td>
                                                <td>Precio unitario</td>
                                                <td>Otros impuestos</td>
                                                <td>Descuento</td>
                                                <td>Ventas gravadas</td>
                                                <td>Ventas exentas</td>
                                                <td>Ventas no sujetas</td>
                                                <td>Acciones</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {tableProductos.map((producto, index) => {
                                                let precioUnitario = 0
                                                let descuento = 0
                                                let gravadas = 0
                                                let noSujeto = 0
                                                let exentas = 0
                                                let detalleTributos = ''
                                                let digitos = getDigitosCalculables(datos?.codigo_empresa)
                                                
                                                let precioConIVA = (parseFloat(producto.precio)/1.13)
                                                let precioSinIVA = parseFloat(producto.precio)

                                                precioUnitario = producto.conIva ? precioConIVA : precioSinIVA
                                                descuento = isNaN(parseFloat(producto.descuento)) ? 0 : producto.tipoDescuento === 'Porcentaje' ? (parseFloat(producto.descuento)/100*precioUnitario) * parseFloat(producto.cantidad) : parseFloat(producto.descuento) 
                                                gravadas = (precioUnitario * parseFloat(producto.cantidad)) - descuento
                                                let gravadasDecimal = gravadas.toFixed(digitos)
                                                exentas = (precioUnitario * parseFloat(producto.cantidad)) - descuento
                                                noSujeto = (precioUnitario * parseFloat(producto.cantidad)) - descuento
                                                detalleTributos = processDetalleImpuestosHTML(productosCatalogo, '03', producto, gravadas);

                                                return(
                                                <tr key={index}>
                                                    <td data-label="Cantidad">{producto.cantidad}</td>
                                                    <td data-label="Tipo">{`${producto.servicio ? 'Servicio' : 'Producto'} ${producto.exento ? ' exento' : ''}`}</td>
                                                    <td data-label="Descripción" style={{wordBreak:"break-all"}}>{<div dangerouslySetInnerHTML={{ __html: producto.descripcion }} />}</td>
                                                    <td data-label="Precio unitario">{precioUnitario.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: digitos, style: 'currency', currency: 'USD'})}</td>
                                                    <td data-label="Otros impuestos"><div dangerouslySetInnerHTML={{ __html: detalleTributos }} /></td>
                                                    <td data-label="Descuento">{isNaN(descuento) ? '$0.00' : descuento.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: digitos, style: 'currency', currency: 'USD'})}</td>
                                                    <td data-label="Ventas gravadas">{(!producto.exento && !producto.noSujeto) ? (isNaN(gravadas) ? '$0.00' : gravadas.toLocaleString('es-SV', { minimumFractionDigits: 2, maximumFractionDigits: digitos, style: 'currency', currency: 'USD' })) : '$0.00'}</td>
                                                    <td data-label="Ventas exentas">{producto.exento ? (isNaN(exentas) ? '$0.00' : exentas.toLocaleString('es-SV', {minimumFractionDigits: 2, maximumFractionDigits: digitos, style: 'currency', currency: 'USD'})): '$0.00'}</td>
                                                    <td data-label="Ventas no sujetas">{producto.noSujeto ? (isNaN(noSujeto) ? "$0.00" : noSujeto.toLocaleString("es-SV", { minimumFractionDigits: 2, maximumFractionDigits: digitos, style: "currency", currency: "USD" })) : "$0.00"}</td>
                                                    <td data-label="Acciones">
                                                        <button onClick={() => actionButton_editar(producto, index)}><img src={EditIcon} alt="edit"/></button>
                                                        <button onClick={() => actionButton_eliminarProducto(index)}><img src={DeleteIcon} alt="delete"/></button>
                                                    </td>
                                                </tr>
                                            )})}
                                        </tbody>
                                    </table>
                                </div>
                                <Pagination data = {productos} state = {(items: Array<any>) => setTableProductos(items)} items = {10}/>
                                <InputForm required name = 'granContribuyente' label = 'No realizar retención renta' type = 'checkbox' value = {retencionRenta} onChange = {(e: any) => handleChangeRetencionRenta()}/>
                                <div className="cf-calculos-producto">

                                    <table>
                                        <tbody>
                                            <tr className="cf-subtotal">
                                                <td>Suma de operaciones</td>
                                                <td>{formatearNum(calculosProductos().sumaOperaciones)}</td>
                                            </tr>
                                            <tr className="cf-subtotal">
                                                <td>Impuesto al Valor Agregado 13%</td>
                                                <td>{formatearNum(calculosProductos().iva)}</td>
                                            </tr>
                                            <tr className="cf-subtotal">
                                                <td>Otros impuestos
                                                </td>
                                                <td>{formatearNum(calculosProductos().otrosImpuestos)}</td>
                                            </tr>
                                            <tr className="cf-subtotal">
                                                <td>Subtotal</td>
                                                <td>{formatearNum(calculosProductos().subtotal)}</td>
                                            </tr>
                                            <tr className="cf-subtotal">
                                                <td>IVA percibido 1%</td>
                                                <td>{formatearNum(calculosProductos().ivaPercibido)}</td>
                                            </tr>
                                            <tr className="cf-subtotal">
                                                <td>IVA retenido 1%</td>
                                                <td>{formatearNum(calculosProductos().ivaRetenido)}</td>
                                            </tr>
                                            <tr className="cf-descuento">
                                                <td>Retencion renta 10%</td>
                                                <td>{formatearNum(calculosProductos().retencionRenta)}</td>
                                            </tr>
                                            {propinaConfig?.propina_activa &&(
                                            <tr className="cf-descuento">
                                                <td>Monto propina {(propinaConfig.cantidad_propina * 100).toFixed(0)}%</td>
                                                <td>
                                                    {
                                                        formCliente.propina? formatearNum((calculosProductos().sumaOperaciones + calculosProductos().iva) * propinaConfig.cantidad_propina): "$0.00"
                                                    }
                                                </td>
                                            </tr>
                                            )}
                                            <tr className="cf-total">
                                                <td>Total</td>
                                                <td>{formatearNum(calculosProductos().total)}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <FormaPago totalAPagar={calculosProductos().total.toString()}/>
                        </BasicCardDocumentos>
                </div>
                <div className="w-layout-layout bill-section wf-layout-layout">
                    <div></div>
                    <ObservacionesDocumentoBase formObservaciones={formObservaciones} onChange={(field, value) => dispatch({ type: CREDITO_FISCAL_TYPES.CCF_FORMOBSERVACIONES_HANDLE_CHANGE, payload: { [field]: value } })} />
                    <OtrosDocAsociados />
                    <DocumentosReceptor />
                </div>
                </div>
            </div>
        </>
    )
}